import AppointmentContainer from "./Appointment.container";

export default AppointmentContainer;
